import { AgencySettings, initialAgencySettings } from "./agencySettings"

export type SessionConfig = {
  chat: boolean,
  // audioVideo: boolean, //obsolete
  audio: boolean,
  video: boolean,
  customerAttachments: boolean,
  operatorAttachments: boolean,
  localization: boolean,
  // defaultAfterNull: boolean, //unused!
  maxGuestsNumber: number,
  maxOnSiteOperators: number,
  agencySettings: AgencySettings // dynamic in c#
}

export const initialSessionConfig: SessionConfig = {
  chat: true,
  // audioVideo: true,
  audio: true,
  video: true,
  customerAttachments: true,
  operatorAttachments: true,
  localization: true,
  // defaultAfterNull: true,
  maxGuestsNumber: 6,
  maxOnSiteOperators: 6,
  agencySettings: initialAgencySettings
}
